export enum AlignmentType {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}
